<template>
	<pre v-html="$t('terms.privacy_policy1')"></pre>
</template>

<script>
export default {
	name: 'PrivacyPolicy1',
};
</script>

<style scoped></style>
